<template>
  <el-dialog
    :visible.sync="dialogVisible"
    class="recommend-dialog-v2"
    :close-on-click-modal="false"
    append-to-body
    width="650px"
  >
    <div slot="title" class="dialog-title">
      <span class="recommend-title mr20">推荐须知</span>
      <span>
        <button v-if="company._id" class="alpha-btn mr10" @click="toFeedback">反馈</button>
      </span>
    </div>

    <div class="tab-box">
      <button
        v-for="tab in tabs"
        :key="tab.label"
        :class="[activeTab === tab.label ? 'alpha-btn-primary' : 'alpha-btn','mr10']"
        @click="activeTab = tab.label">
        {{ tab.label }}
      </button>
    </div>

    <div v-if="activeTab === '客户公司推荐须知'" class="recommend-content">
      <p>以下信息来自公司，由客户经理维护，如果疑问可点击【反馈】</p>
      <div class="recommend-item">
        <p class="recommend-title">推荐要求</p>
        <pre :class="!contract['推荐备注']?'gray-text':''">{{ company['推荐备注'] || '暂无信息' }}</pre>
      </div>
      <div class="recommend-item">
        <p class="recommend-title">其他特殊要求</p>
        <pre :class="!contract['特殊要求寻访']?'gray-text':''">{{ company['特殊要求寻访'] || '暂无信息' }}</pre>
      </div>
      <div class="recommend-item">
        <p class="recommend-title">客户系统</p>
        <pre :class="!contract['客户系统']?'gray-text':''">{{ company['客户系统'] || '暂无信息' }}</pre>
      </div>
      <span slot="footer" class="dialog-footer" style="display:flex;justify-content: center;">
        <el-button style="width:100%" size="mini" type="primary" @click="confirm"
          >已经确认推荐须知</el-button
        >
      </span>
    </div>
    <div v-else-if="activeTab === '原项目推荐须知'" class="recommend-content">
      <div class="alert-box">
        <p style="color:#F56C6C">1、系统根据该客户的合同以及阿尔法的工作规则已经对应生成该项目的推荐须知，请确认；</p>
        <p style="color:#F56C6C">2、如果客户有特殊的推荐要求以及面试要求，请认真填写在下方；</p>
        <p style="color:#F56C6C">3、以下推荐须知会在对应的阶段和项目操作中，不断提醒顾问，以防止发生不必要的麻烦；</p>
      </div>
      <div v-if="project['推荐备注']" class="recommend-item">
        <p class="recommend-title">推荐要求（会在人选推荐环节提醒顾问，有特殊要求请填写）</p>
        <pre>{{ project['推荐备注'] }}</pre>
      </div>
      <div v-if="project['面试安排']" class="recommend-item">
        <p class="recommend-title">面试安排（会在安排面试环节提醒顾问）</p>
        <pre>{{ project['面试安排'] }}</pre>
      </div>
      <div v-if="project['佣金结算']" class="recommend-item">
        <p class="recommend-title">佣金结算（来自合同，会在offer和开票时提醒顾问）</p>
        <pre>{{ project['佣金结算'] }}</pre>
      </div>
      <div v-if="project['归属权判定']" class="recommend-item">
        <p class="recommend-title">归属权判定（来自合同）</p>
        <pre>{{ project['归属权判定'] }}</pre>
      </div>
      <div v-if="project['特殊要求寻访']" class="recommend-item">
        <p class="recommend-title">其他特殊要求</p>
        <pre>{{ project['特殊要求寻访'] }}</pre>
      </div>
      <div v-if="project['阿尔法推荐规范']" class="recommend-item">
        <p class="recommend-title">阿尔法推荐规范</p>
        <pre>{{ project['阿尔法推荐规范'] }}</pre>
      </div>
      <span slot="footer" class="dialog-footer" style="display:flex;justify-content: center;">
        <el-button style="width:100%" size="mini" type="primary" @click="confirm"
          >已经确认推荐须知</el-button
        >
      </span>
    </div>
    <div v-else-if="activeTab === '阿尔法质量要求'" class="recommend-content">
      <div class="recommend-item">
        <p class="recommend-title">简历评估和推报检查</p>
        <pre>1."时间线是否完整、连续（空档期或者重合的时间是否标明），每段时间细化到月份"
2."正式入职时间&实习时间，学历、专业、学位"
3.个人信息是否完整，包括年龄、工作地点、婚育状况（女性）
4.工作经历的公司、职位、职级（团队人数）、职责、是否完整
5.推荐概述和职位的公司和岗位是否与所推职位一致（建议不要写明推荐公司名称，切勿包含其他客户名）
6.段落分层格式是否正确、标点符号是否统一
7.离职原因是否可观，不包含抱怨公司的内容
8.推荐语是否与客户关键诉求一致且有案例支持</pre>
      </div>
      <div class="recommend-item">
        <p class="recommend-title">可能出现的问题及解决建议</p>
        <pre>1.在推荐语里呈现了另一家客户的名字
与客户经理第一时间联系，并全面配合解决

2.人选工作经历有断档
与人选check情况及原因，列在推报里

3.人选比较跳
判断是否该人选是最合适的，如果是寻求人选频繁跳动的原因，并按此画像补人；如果不是最合适的，最多选择带推，不做重点，也要了解频繁离职的原因

4.人选本科、硕士等读书时长有偏差
与人选check情况及原因，列在推报里

5.候选人收入情况太笼统（只有年薪，没有税前税后，没有固定奖金比例等）
与人选check情况及原因，列在推报里</pre>
      </div>
      <div class="recommend-item">
        <p class="recommend-title">推荐报告</p>
        <pre>1、推荐后被客户问询最多的3类基础信息
【学历】比如：硕士是在职吗？这个本科怎么读了5年？
【间隔期】本科与硕士之间的间隔期，每段经历之间的间隔期
【工作地点】人选可以为了职位转换地点，但在推报中不标明
（客户又要来问一遍，甚至可能影响这个人选第一时间的推进）

2、格式错误+错别字→会给客户留下不专业的印象
从系统上把推荐报告down下来，可能出现格式错乱
有些人选的简历是特殊处理过的，在识别成文字时会出现乱码或者错字较多，中后台同事一般会看那么细，但顾问一定要把关

3、一人推多时，推荐报告不要出现其他客户信息
建议不要在推荐报告上出现具体的客户名称

4、不要直接填写VIP标签
可标注过往业绩突出，资源定位在那个方面

【关于重点推荐人选】
1、频繁跳槽的人选-了解人选每段经历的跳槽原因，在推荐概述中讲明（且理由要充分）
2、重点突出，重要的信息往前放，标色、加粗、下划线都行
3、推荐概述要精简、生动，引起对方的兴趣
尤其是比较高量级的岗位、对软性质素比较看重的岗位，需要展现人选的口碑和风格</pre>
      </div>
      <div class="recommend-item">
        <p class="recommend-title">补充说明</p>
        <pre>【基础信息】
1、婚育
2、工作时间/学历时间到月份：比如学历一般都是9月开学，6月毕业。
3、工作经历有较久GAP期要标注原因
4、职位名称要清晰：比如承揽还是承做？尽量避免“承揽承做”
5、对接客户的特殊要求：是否写薪酬、是否写联系方式。

【推荐概述】
1、推荐概述中的业绩信息要更新：经常大家推荐前会用旧推报，一定要注意涉及的内容是否要更新，比如业绩、管理规模等。

【建议】
1、重点人选业绩要重新做表。
2、推荐概述中，关键点放前面，写清楚创收、管理规模、奖项荣誉、资源情况。“名校”概念。

【资格资质】
注意check是否有基金从业/证券从业？
注意check资质的写法，比如“律师资格？”——通过法律职业资格考试考试

【特殊情况】
如果一个人的学历一般，但是你看他的经历都是一些有学历限制的大平台，那就要重点问他是有什么其他方面的能力优势。比如我的一个人3a人选示例</pre>
      </div>
      <span slot="footer" class="dialog-footer" style="display:flex;justify-content: center;">
        <el-button style="width:100%" size="mini" type="primary" @click="confirm"
          >已经确认推荐须知</el-button
        >
      </span>
    </div>
    <div v-else-if="activeTab === '合同注意事项'" class="recommend-content">
      <p>以下信息来自公司，由客户经理维护，如果疑问可点击【反馈】</p>
      <div class="recommend-item">
        <p class="recommend-title">佣金结算</p>
        <pre :class="!contract['佣金结算']?'gray-text':''">{{ contract['佣金结算'] || '暂无信息' }}</pre>
      </div>
      <div class="recommend-item">
        <p class="recommend-title">推荐要求</p>
        <pre :class="!contract['推荐要求']?'gray-text':''">{{ contract['推荐要求'] || '暂无信息' }}</pre>
      </div>
      <div class="recommend-item">
        <p class="recommend-title">归属权判定</p>
        <pre :class="!contract['归属权判定']?'gray-text':''">{{ contract['归属权判定'] || '暂无信息' }}</pre>
      </div>
      <span slot="footer" class="dialog-footer" style="display:flex;justify-content: center;">
        <el-button style="width:100%" size="mini" type="primary" @click="confirm"
          >已经确认推荐须知</el-button
        >
      </span>
    </div>
    <!-- 反馈弹窗 -->
    <CompanyFeedbackDialog ref="CompanyFeedbackDialog"></CompanyFeedbackDialog>
    <!-- <span slot="footer" class="dialog-footer" style="display:flex;justify-content: center;">
      <el-button style="width:100%" size="mini" type="primary" @click="confirm">已经确认推荐须知</el-button>
    </span> -->
  </el-dialog>
</template>
<script>
import CompanyFeedbackDialog from '../../../company/src/FullCompanyV2/Components/CompanyFeedbackDialog'

export default {
  components: { CompanyFeedbackDialog },
  data() {
    return {
      dialogVisible: false,
      company: {},
      project: {},
      contract: {},
      activeTab: '客户公司推荐须知',
      fields: ['佣金结算', '归属权判定', '推荐备注', '面试安排', '特殊要求寻访', '阿尔法推荐规范'],
      projectInEdit: {},
    }
  },
  computed: {
    tabs() {
      const { project } = this
      const arr = [
        { label: '客户公司推荐须知' },
        { label: '阿尔法质量要求' },
        { label: '合同注意事项' },
      ]
      const projectFields = ['推荐备注','面试安排','佣金结算','归属权判定','特殊要求寻访','阿尔法推荐规范']
      let projectFlag = false
      for(const field of projectFields){
        if(project[field]) projectFlag = true
      }
      if(projectFlag) arr.push({ label: '原项目推荐须知' })
      return arr
    },
  },
  methods: {
    async open({project,cid,companyName}){
      if(!cid && !companyName) return this.$message.error('参数错误')
      this.cid = cid
      this.companyName = companyName
      this.project = project
      this.dialogVisible = true
      this.getCompany()
    },
    toFeedback(){
      this.$refs.CompanyFeedbackDialog.open({cid:this.company._id,type:'推荐须知',title:'推荐须知'})
    },
    confirm() {
      this.dialogVisible = false
      this.$emit('confirm')
    },
    async getCompany() {
      const { cid, companyName } = this
      const res = await app.service('company').getCompany(cid ? { _id: cid } : { 简称: companyName })
      if(res.status === 200 || res.status === 'success'){
        this.company = res.result
        const attas = this.company.附件 || []
        attas.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))
        const contract = attas.find(v => v.type === '合同') || {}
        this.contract = contract && contract.合同详情 || {}
      }
    },
  },
}
</script>
<style src="../../../company/statistics/css/common.css" scoped></style>
<style>
.recommend-dialog-v2 .el-dialog__body {
  padding-top: 0px;
}
</style>
<style scoped>
.tab-box{
  padding-top: 10px;
  padding-bottom: 10px;
}
.recommend-content {
  display: flex;
  flex-direction: column;
}
.alert-box {
  padding: 10px 10px;
}
.recommend-item {
  padding-bottom: 16px;
}
.recommend-title {
  font-size: 16px;
  font-weight: 600;
  padding-top: 10px;
  padding-bottom: 10px;
}
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
